function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';

/**
 * This component creates an extra `div` in the DOM to be able to listen to clicks
 * outside of the wrapped component.
 * The user can tweak the properties of such element with the `extra` parameter.
 */
var onClickOutside = function onClickOutside() {
  var propName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'onClickOutside';
  var extra = arguments.length > 1 ? arguments[1] : undefined;
  return function (Component) {
    var OnClickOutside = /*#__PURE__*/function (_React$Component) {
      _inherits(OnClickOutside, _React$Component);
      var _super = _createSuper(OnClickOutside);
      function OnClickOutside(props) {
        var _this;
        _classCallCheck(this, OnClickOutside);
        _this = _super.call(this, props);
        _this.ref = /*#__PURE__*/React.createRef();
        _this.calculateClassName = _this.calculateClassName.bind(_assertThisInitialized(_this));
        _this.handleOnClickOutside = _this.handleOnClickOutside.bind(_assertThisInitialized(_this));
        return _this;
      }
      _createClass(OnClickOutside, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (!document) {
            console.warn('OnClickOutside: cannot register listener. no document.');
          } else {
            document.addEventListener('mousedown', this.handleOnClickOutside);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (document) {
            document.removeEventListener('mousedown', this.handleOnClickOutside);
          }
        }
      }, {
        key: "calculateClassName",
        value: function calculateClassName() {
          if (!extra || !extra.className) return null;
          if (typeof extra.className === 'function') return extra.className(this.props);
          return extra.className;
        }
      }, {
        key: "handleOnClickOutside",
        value: function handleOnClickOutside(event) {
          if (this.ref.current.contains(event.target)) return;
          if (!this.props[propName]) {
            console.warn('cannot find onClickOutside prop name', propName);
            return;
          }
          if (typeof this.props[propName] !== 'function') {
            console.warn('onClickOutside prop', propName, 'is not a function!');
            return;
          }
          this.props[propName](event, this.props);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement("div", {
            ref: this.ref,
            className: this.calculateClassName()
          }, /*#__PURE__*/React.createElement(Component, this.props));
        }
      }]);
      return OnClickOutside;
    }(React.Component);
    return OnClickOutside;
  };
};
export default onClickOutside;